module.exports = __webpack_public_path__ + "img/percayso-logo.06c23f8d.png";